/** `{ imageType, url, altText }` on the `Image` type. */
export const imageFragment = `
  fragment ImageFragment on Image {
    imageType
    url
    altText
  }
`;

/** Progress fields shared by the bookmark / continue-watching queries. */
export const bookmarkFieldsFragment = `
  fragment BookmarkFields on Bookmark {
    contentId
    mediaId
    progressPercentage
    remainingTimeLabel
  }
`;

/**
 * Core selection shared by `contentsByMediaId` / `contentsBySeasonId`.
 * References `ImageFragment`, so consuming documents must also append
 * `imageFragment`. Each query adds its own extensions (parental control,
 * maturity ratings, etc.) alongside the spread.
 */
export const contentFieldsFragment = `
  fragment ContentFields on ContentMetadata {
    path
    title
    id
    shortDescription
    locked
    seasonNumber
    episodeNumber
    contentType
    duration {
      timeInSecs
      timeLabel
      timeAccessibilityLabel
      progressPercentage
      remainingTimeInSecs
      remainingTimeLabel
      remainingTimeAccessibilityLabel
    }
    metadataImages {
      poster {
        ...ImageFragment
      }
      thumbnail {
        ...ImageFragment
      }
    }
    badge {
      label
      detailedLabel
    }
    languageIndicators {
      indicator
      languages {
        langCode
        displayTitle
        locked
      }
    }
    broadcastDate
    flags {
      flag
      label
      detailedLabel
    }
  }
`;
